import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import {
  Authenticate,
  OauthAEMConfig,
  SelectDevicePayload
} from '../../../models';
import { UtilService } from '../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class RemoveMfaMethodService {
  submitSmsNumberHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.removeDevice+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  removeMFAMethod = (
    authConfig: OauthAEMConfig,
    flowIdValue: string,
    deviceId: string
  ): Observable<Authenticate> => {
    const removeMFAMethod = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const removeMFAMethodUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: removeMFAMethod
      }
    ];

    const payload: SelectDevicePayload = {
      deviceRef: {
        id: deviceId
      }
    };

    return new ApiBuilder<SelectDevicePayload, Authenticate>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(removeMFAMethodUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .payload(payload)
      .httpHeaders(this.submitSmsNumberHeader)
      .errorHandler(this._errorHandler)
      .library('REMOVE_MFA_METHOD_SERVICE')
      .withCredentials(true)
      .create();
  };
}
